import dayjs from 'dayjs';

/** Longest stay in nights that a room search may cover. Matches the backend limit (Domain.Constants.MaxRoomRateStayNights). */
export const MAX_STAY_NIGHTS = 31;

/** Number of nights between arrival and departure, ignoring the time of day. NaN if either date is invalid. */
export function getStayNights(arrival: Date | string, departure: Date | string): number {
  return dayjs(departure).startOf('day').diff(dayjs(arrival).startOf('day'), 'day');
}

/** True when the stay is 1..MAX_STAY_NIGHTS nights, which is what the availability API accepts. */
export function isValidStayLength(arrival: Date | string, departure: Date | string): boolean {
  const nights = getStayNights(arrival, departure);
  return nights >= 1 && nights <= MAX_STAY_NIGHTS;
}

/** Latest departure date allowed for the given arrival. */
export function getMaxDepartureDate(arrival: Date | string): Date {
  return dayjs(arrival).startOf('day').add(MAX_STAY_NIGHTS, 'day').toDate();
}
